import { getJSON } from 'bv-fetch';
import { loggedIn } from 'bv-helpers/session';

export default () => (
  getJSON(`/api/right_components?l=${loggedIn()}`)
);
